import { Component, OnInit } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ActivatedRoute } from '@angular/router';
import { ProcessToken } from './core/models/process-token';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  checked = false;
  activeButtons = true;
  signatoryName: string;
  signatoryEmail: string;
  timeOut = true;
  action = false;
  hideContinue = false;
  selectedLanguage: string;
  showDropdown = false;

  private readonly URL_LANGUAGE_MAP = {
    'psa-esign-esp': 'sp',
    'psa-esign-pt': 'por',
    'psa-esign-ita': 'it'
  };

  private readonly DEFAULT_LANGUAGE = 'fr';

  languages = [
    { code: 'en', flag: 'en.svg', langue: 'English' },
    { code: 'fr', flag: 'fr.svg', langue: 'Français' },
    { code: 'sp', flag: 'sp.svg', langue: 'Español' },
    { code: 'por', flag: 'por.svg', langue: 'Português' },
    { code: 'it', flag: 'it.svg', langue: 'Italiano' }
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const initialLanguage =  this.detectLanguageFromUrl();
    this.setLanguage(initialLanguage);
  }

  private detectLanguageFromUrl(): string {
    const hostname = window.location.hostname;

    for (const [urlPattern, lang] of Object.entries(this.URL_LANGUAGE_MAP)) {
      if (hostname.includes(urlPattern)) {
        return lang;
      }
    }
    return this.DEFAULT_LANGUAGE;
  }

  private setLanguage(lang: string): void {
    this.selectedLanguage = lang;
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    sessionStorage.setItem('selectedLanguage', lang);
  }
  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }
  changeLanguage(lang: string): void {
    this.setLanguage(lang);
    this.showDropdown = false;
  }
  enableSign(value: boolean): void {
    this.activeButtons = !value;
    this.hideContinue = true;


  }
  receiveSignRefuse(action: boolean) {
    this.action = action;
  }


  receiveprofilInformation(processToken: ProcessToken) {
    if (isNotNullOrUndefined(processToken)) {
      this.signatoryEmail = processToken.signatoryEmail;
      this.signatoryName = processToken.signatoryName;

    }
  }
  receiveTimeOut(isValid: boolean) {
    this.timeOut = isValid;
  }
}
